import { render } from "./explainGeneral.vue?vue&type=template&id=a08f0f6e"
import script from "./explainGeneral.vue?vue&type=script&lang=js"
export * from "./explainGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__